import Vue from 'vue'
import Router from 'vue-router'
//  一级路由
// import Home from '../pages/Home/Home' // 首页
// import CityExpress from '../pages/Courier/Express/CityExpress' // 同城快递
import ConfirmOrder from '../pages/Courier/Express/ConfirmOrder' // 国内确定订单
import Ticket from '../pages/Courier/Ticket/Ticket' // 票务服务
import TicketOrder from '../pages/Courier/Ticket/TicketOrder' // 票务服务确认订单
import Other from '../pages/Courier/Other/Other' // 其他服务
import OtherOrder from '../pages/Courier/Other/OtherOrder' // 其他服务确认订单
import Medical from '../pages/Courier/Hospital/Medical' // 医疗服务
import Hospital from '../pages/Courier/Hospital/Hospital' // 医院详情
import HospitalOrder from '../pages/Courier/Hospital/HospitalOrder' // 医院确认订单
import Person from '../pages/Person/Person' // 个人中心
import Courier from '../pages/Courier/Courier' // 下单
import Download from '../pages/Download/Download' // 下载中心
import ChangePassword from '../pages/Login/ChangePassword' // 修改密码
import FindPassword from '../pages/Login/FindPassword' // 找回密码
import NormalRegister from '../pages/Login/NormalRegister' // 普通注册
import MerchantRegister from '../pages/Login/MerchantRegister' // 商家注册
import MerchantInfo from '../pages/Login/MerchantInfo' // 商家信息
import Login from '../pages/Login/Login' // 登录
import Profile from '../pages/Home/Profile' // 公司简介
import About from '../pages/Home/About' // 联系我们
import Staff from '../pages/Home/Staff' // 成为员工
import Issue from '../pages/Home/Issue' // 常见问题
import League from '../pages/Home/League' // 常见问题
import RichText from '../pages/Home/RichText' // 富文本
import Price from '../pages/Price/Price' // 服务价格
import Success from '../pages/Person/Children/Success'

// 二级路由
import Detail from '../pages/Courier/Children/Hospital/Detail' // 医院详情
import Doctor from '../pages/Courier/Children/Hospital/Doctor' // 医生列表
import DoctorDetail from '../pages/Courier/Children/Hospital/DoctorDetail' // 医生详情
// 个人中心
import Datum from '../pages/Person/Children/Datum' // 我的资料
import Wallet from '../pages/Person/Children/Wallet' // 我的钱包
import Recharge from '../pages/Person/Children/Recharge' // 充值
import Coupon from '../pages/Person/Children/Coupon' // 充值

import Order from '../pages/Person/Children/MyOrder' // 我的订单
import HosOrder from '../pages/Person/Children/HosOrder' // 医院订单详情
import ExpressOrderDetail from '../pages/Person/Children/ExpressOrder' // 快递订单详情
import TicketOrderDetail from '../pages/Person/Children/TicketOrder' // 票务订单详情
import OtherOrderDetail from '../pages/Person/Children/OtherOrder' // 其他订单详情
import ExpressAgain from '../pages/Person/Children/ExpressAgain' // 快递订单再来一单
import HospitalAgain from '../pages/Person/Children/HospitalAgain' // 医疗订单再来一单
import TicketAgain from '../pages/Person/Children/TicketAgain' // 票务订单再来一单
import OtherAgain from '../pages/Person/Children/OtherAgain' //  其他服务再来一单
import Complain from '../pages/Person/Children/Complain' //  投诉
import Patient from '../pages/Person/Children/Patient' //  我的就诊人
import EditPatient from '../pages/Person/Children/EditPatient' //  我的就诊人
import Passenger from '../pages/Person/Children/Passenger' //  我的乘客
import EditPassenger from '../pages/Person/Children/EditPassenger' //  我的乘客
import Bill from '../pages/Person/Children/Bill' //  我的发票
import BillApply from '../pages/Person/Children/BillApply' //  我的发票
import BillDetail from '../pages/Person/Children/BillDetail' //  我的发票
import Info from '../pages/Person/Children/Info' // 消息详情
import Express from '../pages/Person/Children/Express' // 一线快递
import Address from '../pages/Person/Children/Address' // 地址管理

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/pages/Home/Home')
    },
    {
      path: '/courier/cityExpress',
      name: 'CityExpress',
      component: () => import('@/pages/Courier/Express/CityExpress'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/courier/confirmOrder',
      name: 'ConfirmOrder',
      component: () => import('@/pages/Courier/Express/ConfirmOrder'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/courier/ticket',
      name: 'Ticket',
      component: () => import('@/pages/Courier/Ticket/Ticket')
    },
    {
      path: '/courier/ticketOrder',
      name: 'TicketOrder',
      component: () => import('@/pages/Courier/Ticket/TicketOrder'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/courier/other',
      name: 'Other',
      component: () => import('@/pages/Courier/Other/Other')
    },
    {
      path: '/courier/otherOrder',
      name: 'OtherOrder',
      component: () => import('@/pages/Courier/Other/OtherOrder')
    },
    {
      path: '/courier/medical',
      name: 'Medical',
      component: () => import('@/pages/Courier/Hospital/Medical')
    },
    {
      path: '/courier/hospital',
      name: 'Hospital',
      component: () => import('@/pages/Courier/Hospital/Hospital'),
      children: [
        {
          path: '/courier/hospital',
          redirect: '/courier/hospital/detail'
        },
        {
          path: 'detail',
          name: 'Detail',
          component: () => import('@/pages/Courier/Children/Hospital/Detail')
        },
        {
          path: 'doctor',
          name: 'Doctor',
          component: () => import('@/pages/Courier/Children/Hospital/Doctor')
        },
        {
          path: 'doctorDetail',
          name: 'DoctorDetail',
          component: () => import('@/pages/Courier/Children/Hospital/DoctorDetail')
        }
      ]
    },
    {
      path: '/courier/hospitalOrder',
      name: 'HospitalOrder',
      component: () => import('@/pages/Courier/Hospital/HospitalOrder'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/person',
      name: 'Person',
      component: () => import('@/pages/Person/Person'),
      children: [
        {
          path: '/person',
          redirect: '/person/datum'
        },
        {
          path: 'datum',
          name: 'Datum',
          component: () => import('@/pages/Person/Children/Datum')
        },
        {
          path: 'wallet',
          name: 'Wallet',
          component: () => import('@/pages/Person/Children/Wallet')
        },
        {
          path: '/person/wallet/recharge',
          name: 'Recharge',
          component: () => import('@/pages/Person/Children/Recharge')
        },
        {
          path: 'coupon',
          name: 'Coupon',
          component: () => import('@/pages/Person/Children/Coupon')
        },
        {
          path: 'order',
          name: 'Order',
          component: () => import('@/pages/Person/Children/MyOrder')
        },
        {
          path: '/person/order/expressOrderDetail',
          name: 'ExpressOrderDetail',
          component: () => import('@/pages/Person/Children/ExpressOrder')
        },
        {
          path: '/person/order/hosOrder',
          name: 'HosOrder',
          component: () => import('@/pages/Person/Children/HosOrder')
        },
        {
          path: '/person/order/ticketOrderDetail',
          name: 'TicketOrderDetail',
          component: () => import('@/pages/Person/Children/TicketOrder')
        },
        {
          path: '/person/order/otherOrderDetail',
          name: 'OtherOrderDetail',
          component: () => import('@/pages/Person/Children/OtherOrder')
        },
        {
          path: '/person/order/expressAgain',
          name: 'ExpressAgain',
          component: () => import('@/pages/Person/Children/ExpressAgain'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/person/order/hospitalAgain',
          name: 'HospitalAgain',
          component: () => import('@/pages/Person/Children/HospitalAgain')
        },
        {
          path: '/person/order/ticketAgain',
          name: 'TicketAgain',
          component: () => import('@/pages/Person/Children/TicketAgain')
        },
        {
          path: '/person/order/otherAgain',
          name: 'OtherAgain',
          component: () => import('@/pages/Person/Children/OtherAgain')
        },
        {
          path: '/person/order/complain',
          name: 'Complain',
          component: () => import('@/pages/Person/Children/Complain')
        },
        {
          path: 'patient',
          name: 'Patient',
          component: () => import('@/pages/Person/Children/Patient')
        },
        {
          path: '/person/patient/edit',
          name: 'EditPatient',
          component: () => import('@/pages/Person/Children/EditPatient')
        },
        {
          path: 'passenger',
          name: 'Passenger',
          component: () => import('@/pages/Person/Children/Passenger')
        },
        {
          path: '/person/passenger/edit',
          name: 'EditPassenger',
          component: () => import('@/pages/Person/Children/EditPassenger')
        },
        {
          path: 'bill',
          name: 'Bill',
          component: () => import('@/pages/Person/Children/Bill')
        },
        {
          path: '/person/bill/apply',
          name: 'BillApply',
          component: () => import('@/pages/Person/Children/BillApply')
        },
        {
          path: '/person/bill/detail',
          name: 'BillDetail',
          component: () => import('@/pages/Person/Children/BillDetail')
        },
        {
          path: 'info',
          name: 'Info',
          component: () => import('@/pages/Person/Children/Info')
        },
        {
          path: 'express',
          name: 'Express',
          component: () => import('@/pages/Person/Children/Express')
        },
        {
          path: 'address',
          name: 'Address',
          component: () => import('@/pages/Person/Children/Address')
        }
      ]
    },
    {
      path: '/download',
      name: 'Download',
      component: () => import('@/pages/Download/Download')
    },
    {
      path: '/courier',
      name: 'Courier',
      component: () => import('@/pages/Courier/Courier')
    },
    {
      path: '/changePassword',
      name: 'ChangePassword',
      component: () => import('@/pages/Login/ChangePassword')
    },
    {
      path: '/findPassword',
      name: 'FindPassword',
      component: () => import('@/pages/Login/FindPassword')
    },
    {
      path: '/normalRegister',
      name: 'NormalRegister',
      component: () => import('@/pages/Login/NormalRegister')
    },
    {
      path: '/merchantRegister',
      name: 'MerchantRegister',
      component: () => import('@/pages/Login/MerchantRegister')
    },
    {
      path: '/merchantInfo',
      name: 'MerchantInfo',
      component: () => import('@/pages/Login/MerchantInfo')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/Login/Login')
    },
    {
      path: '/home/profile',
      name: 'Profile',
      component: () => import('@/pages/Home/Profile')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('@/pages/Home/About')
    },
    {
      path: '/home/staff',
      name: 'Staff',
      component: () => import('@/pages/Home/Staff')
    },
    {
      path: '/home/issue',
      name: 'Issue',
      component: () => import('@/pages/Home/Issue')
    },
    {
      path: '/home/league',
      name: 'League',
      component: () => import('@/pages/Home/League')
    },
    {
      path: '/home/richText',
      name: 'RichText',
      component: () => import('@/pages/Home/RichText')
    },
    {
      path: '/price',
      name: 'Price',
      component: () => import('@/pages/Price/Price')
    },
    {
      path: '/success',
      name: 'Success',
      component: () => import('@/pages/Person/Children/Success')
    }
  ]
})
// 路由守卫
/*
*   to:router即将进入的路由对象
    from:当前导航即将离开的路由
    next:Function,进行管道中的一个钩子，如果执行完了，则导航的状态就是 confirmed （确认的）；否则为false，终止导航。
          afterEach函数不用传next()函数
* */
router.beforeEach((to, from, next) => {
  const isLogin = !!localStorage.sessionId
  if (to.path === '/login' || to.path === '/merchantRegister' || to.path === '/normalRegister' || to.path === '/merchantInfo' || to.path === '/' || to.path === '/home' || to.path === '/about' || to.path === '/home/richText' || to.path === '/home/league' || to.path === '/home/issue' || to.path === '/home/staff' || to.path === '/findPassword' || to.path === '/download' || to.path === '/price' || to.path === '/home/profile') {
    next()
  } else {
    if (isLogin) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js